/* eslint no-unused-vars: "off" */
import React from 'react';
import { CarvanaCareTypes } from '../../../constants';
import { CarvanaCareDetailsWrapper } from './CarvanaCareDetails.styles';
import {
  CarvanaCareEssential,
  CarvanaCarePlus,
  CarvanaCarePremier,
  CarvanaCareSubscription,
} from './CarvanaCareTypes';

const CarvanaCareDetails = ({ careDetails }: any) => {
  const { type, deductible } = careDetails;

  return (
    <CarvanaCareDetailsWrapper>
      {type === CarvanaCareTypes.Essential && (
        <CarvanaCareEssential deductible={deductible} />
      )}
      {type === CarvanaCareTypes.Plus && (
        <CarvanaCarePlus deductible={deductible} />
      )}
      {type === CarvanaCareTypes.Premier && (
        <CarvanaCarePremier deductible={deductible} />
      )}
      {type === CarvanaCareTypes.Subscription && (
        <CarvanaCareSubscription deductible={deductible} />
      )}
    </CarvanaCareDetailsWrapper>
  );
};

export default CarvanaCareDetails;
